
import SectionForm from "~/components/quiz/sections/SectionForm.vue";
import SectionCities from "~/components/quiz/sections/SectionCities.vue";
import SectionRadioButtons from "~/components/quiz/sections/SectionRadioButtons.vue";
import SectionCheckboxImages from "~/components/quiz/sections/SectionCheckboxImages.vue";
import SectionCargoDimensions from "~/components/quiz/sections/SectionCargoDimensions.vue";
import {getAdditionalData, parseUtmLabels} from "~/helpers/formSend";
import errorParseNetwork from "~/helpers/errorParseNetwork";

export default {
  name: "PopUpQuiz",

  data: function () {
    return {
      form: {},
      activeStage: 0
    }
  },

  computed: {
    quizBlock: function () {
      return this.$store.state?.quiz?.configBlock || {}
    },

    title: function () {
      return this.quizBlock?.cfgs?.title || "Узнайте точную стоимость грузоперевозки, ответив на 6 вопросов"
    },
    sections: function () {
      const initSection = this.quizBlock?.values?.sections || [];
      let sections = initSection.map((t) => {
        return {
          ...t,
          component: t.type
        }
      });
      sections.push({
        type: "SectionForm",
        title: "Вам осталось заполнить форму ниже, чтобы получить расчет стоимости и сроков перевозки",
        help: "<sup style='color: #00A6E2'>*</sup> - обязательно к заполнению",
        component: SectionForm
      })


      return sections
    },
    reachGoalOpen: function () {
      return this?.quizBlock?.cfgs?.reach_goal_open
    },
    reachGoalSend: function () {
      return this?.quizBlock?.cfgs?.reach_goal_send
    },

    isOpen: function () {
      return this.$store.state.quiz?.isOpen || false
    },
    activeSection: function () {
      return this.sections?.[this.activeStage]
    },
    isDisabledNext: function () {
      const section = this.activeSection;
      const formStage = this.form?.[this.activeStage];

      if (section?.type === "SectionCheckboxImages") {
        return Boolean((formStage || []).length <= 0)
      }
      if (section?.type === "SectionCities") {
        return !Boolean(formStage?.['Откуда'] && formStage?.['Куда'])
      }
      if (section?.type === "SectionCargoDimensions") {
        return false
      }
      if (section?.type === "SectionRadioButtons") {
        return Boolean((formStage || []).length <= 0)
      }
      if (section?.type === "SectionForm") {
        return false
      }

      return true
    },
    isUseRecaptcha: function () {
      return Boolean(this.$store.state.appState?.config?.useReCaptchaForForms)
    },
  },

  components: {
    ProgressLine: () => import("./sections/ProgressLine.vue"),

    SectionForm,
    SectionCities,
    SectionRadioButtons,
    SectionCheckboxImages,
    SectionCargoDimensions
  },

  watch: {
    isOpen: function () {
      if (this.isOpen) {
        (async () => {
          this.bodyScrollDisabled();
          await this.$store.dispatch("quiz/getCongif");
          this.loadIntermediateProgress();
          if (this.reachGoalOpen) {
            this.$yandexMetrika.reachGoal(this.reachGoalOpen);
          }
        })();
      } else {
        this.form = {};
        this.activeStage = 0;
        this.bodyScrollEnabled();
      }
    },
  },

  methods: {
    close: function () {
      this.$store.commit("quiz/close");
    },

    changeForm: function (form) {
      this.form = form;
      this.saveIntermediateProgress();
    },
    submitForm: async function (formUser, codeRecaptcha = '') {

      const body = {
        type: "скидка 10%",
        name: formUser.name,
        phone: (formUser?.phone || "").replace(/[^\d]/g, ''),
        message: formUser?.message || '',
        url: window.location.href,
      };
      if (this.isUseRecaptcha && !codeRecaptcha) {
        this.$store.commit("recaptcha/onOpen", {
          onSubmit: this.submitForm.bind(this, formUser)
        })
        return
      }
      if (this.isUseRecaptcha && codeRecaptcha) {
        body['g-recaptcha-response'] = codeRecaptcha;
      }

      const message = this.sections
        .map((section, index) => {
        const formStage = this.form?.[index];

        if (section.type === "SectionForm") {
          return null
        }
        if (section?.type === "SectionCheckboxImages") {
          return `${section.title}: ${(section?.items || []).filter((t, index) => (formStage || []).includes(index)).map((t) => t.name).join(", ")}`
        }
        if (section?.type === "SectionCities") {
          return `Откуда: ${formStage?.['Откуда']}; Куда: ${formStage?.['Куда']}`
        }
        if (section?.type === "SectionCargoDimensions" && formStage) {
          let str = [];
          Object.keys(formStage).map((key) => {
            str.push(`${key}: ${formStage[key]}`)
          })
          return str.join("; ")
        }
        if (section?.type === "SectionRadioButtons") {
          return `${section.title}: ${(section?.items || []).filter((t, index) => (formStage || []).includes(index)).map((t) => t.name).join(", ")}`
        }
        return null
      })
        .filter((t) => !!t)
        .join(";<br/>");
      body.message = message;

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: true });

      const utmLabels = parseUtmLabels();
      if (utmLabels) {
        body.additional_data = {
          ...(body.additional_data || {}),
          ...utmLabels
        }
      }
      body.source = this.$cookies.get('sbjs_current') || '';
      body.additional_data = await getAdditionalData({...body.additional_data}, {
        $yandexMetrika: this.$yandexMetrika
      });
      const response = await this.$api.agent.transport.post("/form/send", body).then((res) => {
        return res.data
      }).catch((err) => {
        return {
          error: errorParseNetwork(err.response)
        }
      });
      if (response.error) {
        this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });

        this.$toast.error(response.error);

        return
      }

      this.$store.commit("loading/setLoading", { name: 'popUpLoading', value: false });
      this.$yandexMetrika.reachGoal(this.reachGoalSend);
      this.$yaglaaction(this.reachGoalSend);
      this.close();
      this.$store.commit("back-call-custom/setOpen", {
        open: true,
        settings: {
          title: "Спасибо за уточнение вашего запроса!",
          message: "Наш менеджер свяжется с Вами в течение 5 минут!"
        }
      });
      this.resetIntermediateProgress();
    },

    prevStage: function () {
      this.activeStage = this.activeStage - 1;
      this.saveIntermediateProgress();
    },
    nextStage: function () {
      const newState = this.activeStage + 1;
      if (newState === this.sections.length) {
        this.$refs?.[`refSection${this.activeStage}`]?.[0].submitForm()
        return
      }
      this.activeStage = newState;
      this.saveIntermediateProgress();
    },

    bodyScrollEnabled: function () {
      document.body.style = "";
    },
    bodyScrollDisabled: function () {
      document.body.style.overflow = "hidden";
    },

    loadIntermediateProgress: function () {
      let config = this.$cookies.get('quiz_progress');
      if (!config) {
        return
      }

      this.form = config?.form || {};
      this.activeStage = config?.stage || 0;
    },
    saveIntermediateProgress: function () {
      const progress = {
        form: this.form,
        stage: this.activeStage
      };
      this.$cookies.set('quiz_progress', progress, {path: "/"});
    },
    resetIntermediateProgress: function () {
      this.$cookies.remove('quiz_progress');
    },
  }
}
